export const BYTES_IN_GB = 1024 * 1024 * 1024;
export const BYTES_IN_TB = BYTES_IN_GB * 1024;

export const bytesToGb = (trafficBytes: number) => {
  if (!trafficBytes) {
    return 0;
  }
  const trafficGb = trafficBytes / BYTES_IN_GB;
  return trafficGb;
}

export const gbToBytes = (trafficGb: number) => {
  if (!trafficGb) {
    return 0;
  }
  const trafficBytes = trafficGb * BYTES_IN_GB;
  return trafficBytes;
}

export const formatGbToUserNumber = (trafficGb: number) => {
  if (!trafficGb) {
    return "0.0";
  }
  return Intl.NumberFormat(navigator.language, {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
  }).format(trafficGb);
}
export const formatBytesToGb = (trafficBytes: number) => {
  return formatGbToUserNumber(bytesToGb(trafficBytes))
}